import { render, staticRenderFns } from "./questionMarkB.vue?vue&type=template&id=2e8f4756&scoped=true"
import script from "./questionMarkB.vue?vue&type=script&lang=js"
export * from "./questionMarkB.vue?vue&type=script&lang=js"
import style0 from "./questionMarkB.vue?vue&type=style&index=0&id=2e8f4756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8f4756",
  null
  
)

export default component.exports